
import { defineComponent, nextTick } from 'vue'
import BasicCard from '@/components/cards/BasicCard.vue'
import ApiService from '@/services/ApiService'
import { SuiviRechercheEmployeur } from '@/types/portal'
import dateFormat from 'dateformat'
export default defineComponent({
  name: 'AdmissibleTrackingSheet',
  components: { BasicCard },
  mounted () {
    nextTick(() => {
      ApiService.get<SuiviRechercheEmployeur[]>('/admissibles/portal/suiviRechercheEmployeur').then((response) => {
        this.suivis = response.data
      })
    })
  },
  data () {
    return {
      suivis: [] as SuiviRechercheEmployeur[]
    }
  },
  methods: {
    formatDate (date: string) {
      return dateFormat(date, 'dd/mm/yyyy')
    }
  }
})
